const baseUrl = "NCE";

export const nceApplicationForm = (data) => {
	return `${baseUrl}/load-application-form?mobileNumber=${data?.mobileNumber || ""
		}&programmeTypeId=${data?.programmeTypeId || ""}&applicationTypeId=${data?.applicationTypeId || ""
		}`;
};

export const addOrUpdateNceBiodata = () =>
	`${baseUrl}/add-or-update-nce-application-personal-details`;

export const addOrUpdateNceProgramme = () =>
	`${baseUrl}/add-or-update-nce-application-programme-details`;

export const addOrUpdateNceEducation = () =>
	`${baseUrl}/add-or-update-nce-application-educational-history`;

export const addOrUpdateNceOlevel = () =>
	`${baseUrl}/add-or-update-nce-application-olevel-result`;
